import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ConfigService } from './config.service';
import { AuthService } from './auth.service';
import { map, catchError, retry } from 'rxjs/operators';
import { VideoListItem } from '../models/videoListItem';
import { Video } from '../models/video';

@Injectable({
	providedIn: 'root'
})

export class VideoService {

	constructor(private http: HttpClient, private authService: AuthService) { }

  // Video List
	getVideoList(eventGuid: string): Promise<Observable<VideoListItem[]>> {
		return this.authService.GetDefaultHeaders().then((contentHeaders: HttpHeaders) => {

			let videoListApiUrl = ConfigService.APP_SECURITY_API_ENDPOINT + "video/event-v1";

			// NOTE: Backend failed to recognize eventGuid in headers. Must resort to inline method
      // contentHeaders = contentHeaders.append("eventGuid", eventGuid);
			let videoListApiUrl_inline: string = videoListApiUrl + "?eventGuid=" + eventGuid;

			// make http get request
			return this.http.get<VideoListItem[]>(videoListApiUrl_inline, { headers: contentHeaders }).pipe(
				retry(3), // retry a failed request up to 3 times
      	catchError(this.handleVideoListError), // then handle the error
				map(res => res['objectdata']) // on success, data is within 'objectdata' in json
			);
		});
	}

	private handleVideoListError(error: HttpErrorResponse) {
		if (error.error instanceof ErrorEvent) {
		  // A client-side or network error occurred. Handle it accordingly.
		  console.error('An error occurred:', error.error.message);
		} else {
		  // The backend returned an unsuccessful response code.
		  // The response body may contain clues as to what went wrong,
		  console.error(
			`Backend returned code ${error.status}, ` +
			`body was: ${error.error}`);
		}
		// return an observable with a user-facing error message
		return throwError(
		  'Unable to fetch Videos; please try again later.');
  };
  
  // Specific Video
	getVideo(videoGuid: string): Promise<Observable<Video>> {
		return this.authService.GetDefaultHeaders().then((contentHeaders: HttpHeaders) => {

			// NOTE: Backend failed to recognize eventGuid in headers. Must resort to inline method
			//contentHeaders = contentHeaders.append("videoGuid", videoGuid);
			let videoApiUrl = ConfigService.APP_SECURITY_API_ENDPOINT + "video/view-v1";


			let videoApiUrl_inline: string = videoApiUrl + "?videoGuid=" + videoGuid;

			// make http get request
			return this.http.get<Video>(videoApiUrl_inline, { headers: contentHeaders }).pipe(
				retry(3), // retry a failed request up to 3 times
      	catchError(this.handleVideoError) // then handle the error
				// map(res => res['objectdata']) // on success, data is within 'objectdata' in json
			);
		});
	}

	private handleVideoError(error: HttpErrorResponse) {
		if (error.error instanceof ErrorEvent) {
		  // A client-side or network error occurred. Handle it accordingly.
		  console.error('An error occurred:', error.error.message);
		} else {
		  // The backend returned an unsuccessful response code.
		  // The response body may contain clues as to what went wrong,
		  console.error(
			`Backend returned code ${error.status}, ` +
			`body was: ${error.error}`);
		}
		// return an observable with a user-facing error message
		return throwError(
		  'Unable to fetch Video; please try again later.');
  };

}
